module.exports = __webpack_public_path__ + "img/pickup-marker.746e6ed9.svg";